module.exports = __webpack_public_path__ + "img/color-11.2794883.png";